import styled from 'styled-components';
import { font } from '@chegg-ui/theme';
var size = font.size,
  family = font.family,
  lineHeight = font.lineHeight;
var px16 = size.px16,
  px18 = size.px18;
var aspira = family.aspira;
export var OrderSummaryWrapper = styled.div.withConfig({
  componentId: "sc-1hli87v-0"
})(["display:flex;font-family:", ";font-size:", ";flex-direction:column;"], aspira, px16);
export var Row = styled.div.withConfig({
  componentId: "sc-1hli87v-1"
})(["display:flex;line-height:", ";flex-direction:row;justify-content:space-between;&.subTotal .subPrice{white-space:nowrap;}&.total{font-size:", ";font-weight:bold;}div + div{text-align:right;}"], lineHeight.md, px18);
export var DividerRow = styled(Row).withConfig({
  componentId: "sc-1hli87v-2"
})(["min-height:", ";"], px18);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/OrderSummary/styled.js
// module id = 3979
// module chunks = 11